module.exports = __webpack_public_path__ + "img/google.eaab0b54.svg";